import { alpha, Stack, Typography, useTheme } from "@mui/material";
import { Info } from "lucide-react";
import type { FC } from "react";

type Props = {
	text: string;
	isLast?: boolean;
};

export const FlatRowHint: FC<Props> = ({ text, isLast }) => {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			alignItems="flex-start"
			gap={1}
			sx={{
				px: 2,
				py: 1.25,
				borderBottom: isLast
					? "none"
					: `1px solid ${alpha(theme.palette.deprecated.grey[100], 0.6)}`,
			}}
		>
			<Info
				size={16}
				color={theme.palette.deprecated.grey[400]}
				style={{ marginTop: 2, flexShrink: 0 }}
			/>
			<Typography
				variant="deprecatedCaption"
				color={theme.palette.deprecated.grey[500]}
			>
				{text}
			</Typography>
		</Stack>
	);
};
